// extracted by mini-css-extract-plugin
export default {"root":"TeamTable_root__5sEAs","header":"TeamTable_header__eLfgd","inviteButton":"TeamTable_inviteButton__ZxFJo"};